import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-625e2cff"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "escapadoresDisponiveis"
}
const _hoisted_2 = {
  key: 1,
  class: "escapadoresDisponiveis"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.escapadoresQuestoes.length)
    ? (_openBlock(), _createElementBlock("article", _hoisted_1, [
        _createTextVNode(" Escapadores de questões disponíveis: "),
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.escapadoresQuestoes as IEscapadorDeQuestao[], (escapador, indice) => {
            return (_openBlock(), _createElementBlock("li", { key: indice }, _toDisplayString(escapador.toString()), 1))
          }), 128))
        ])
      ]))
    : (_openBlock(), _createElementBlock("article", _hoisted_2, " Nenhum escapador disponível "))
}